import React from 'react';

import { AccountCircle } from '@mui/icons-material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {
  Button,
  FormControl,
  InputAdornment,
  MenuItem,
  NativeSelect,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';
import {
  ExportCsv,
  Toolbar,
  ToolbarPropsOverrides,
} from '@mui/x-data-grid-pro';
import { BrowserView, MobileView } from 'react-device-detect';

import { ProvinceLite } from '../../../@types/State';

declare module '@mui/x-data-grid' {
  interface ToolbarPropsOverrides {
    provinces: ProvinceLite[] | undefined;
    province: ProvinceLite | undefined;
    handleProvinceChange: (event: any) => void;
    opTypes: string[] | undefined;
    opType: string;
    handleOpTypeChange: (event: any) => void;
  }
}

const OpsToolBar: React.FC<ToolbarPropsOverrides> = ({
  provinces,
  province,
  handleProvinceChange,
  opTypes,
  opType,
  handleOpTypeChange,
}) => {
  return (
    <Toolbar>
      <Stack direction='row' sx={{ gap: 0.5, flex: 1 }}>
        <Tooltip title='Export as CSV'>
          <ExportCsv
            render={
              <Button
                variant='text'
                size='small'
                startIcon={<FileDownloadIcon />}
              >
                Export
              </Button>
            }
          />
        </Tooltip>
        <BrowserView>
          {provinces && (
            <TextField
              variant='outlined'
              id='province-select'
              select
              value={province ? province.id : -1}
              size='small'
              sx={{ minWidth: '180px', marginLeft: 1 }}
              onChange={handleProvinceChange}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position='start'>
                      <AccountCircle />
                    </InputAdornment>
                  ),
                },
              }}
            >
              <MenuItem value={-1}>All Provinces</MenuItem>
              {provinces?.map((p, i) => (
                <MenuItem key={i} value={p.id}>
                  {p.name}
                </MenuItem>
              ))}
            </TextField>
          )}
          {opTypes && (
            <TextField
              variant='outlined'
              id='province-select'
              select
              value={opType}
              size='small'
              sx={{ minWidth: '180px', marginLeft: 1 }}
              onChange={handleOpTypeChange}
            >
              <MenuItem value={'All Ops'}>All Ops</MenuItem>
              {opTypes?.map((p) => (
                <MenuItem key={p} value={p}>
                  {p}
                </MenuItem>
              ))}
            </TextField>
          )}
        </BrowserView>
        <MobileView>
          {provinces && (
            <FormControl size='small' variant='outlined'>
              <NativeSelect
                id='native-province-select'
                defaultValue={province ? province.id : -1}
                sx={{ minWidth: '180px' }}
                onChange={handleProvinceChange}
                IconComponent={AccountCircle}
                variant='outlined'
              >
                <option value={-1}>All Provinces</option>
                {provinces?.map((p, i) => (
                  <option key={i} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
          )}
        </MobileView>
      </Stack>
    </Toolbar>
  );
};

export default OpsToolBar;
